<div class="footer-onboarding">
    <ul>
        <li><a href="https://publico.transbank.cl/privacidad">Privacidad</a></li>
        <li><a href="https://www.transbankdevelopers.cl/">Desarrolladores</a></li>
        <li><a href="https://ayuda.transbank.cl/contactanos">Contáctanos</a></li>
    </ul>
</div>